import * as React from "react";

type Props = {
    className?: string;
    fill?: string;
};

const DollarSignFilled = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill ?? "none"}
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.1 17h1.75v-1.25q1.25-.225 2.15-.975t.9-2.225q0-1.05-.6-1.925T10.9 9.1q-1.5-.5-2.075-.875T8.25 7.2t.463-1.025T10.05 5.8q.8 0 1.25.388.45.387.65.962l1.6-.65a3.35 3.35 0 0 0-1.013-1.525q-.737-.65-1.637-.725V3H9.15v1.25q-1.25.275-1.95 1.1T6.5 7.2q0 1.175.688 1.9t2.162 1.25q1.576.575 2.188 1.025t.612 1.175q0 .825-.588 1.212-.587.388-1.412.388t-1.463-.513T7.75 12.1l-1.65.65q.35 1.2 1.088 1.938.737.737 1.912 1.012zm.9 3a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137Q1.575 15.725.788 13.9A9.7 9.7 0 0 1 0 10q0-2.074.788-3.9a10.1 10.1 0 0 1 2.137-3.175Q4.275 1.575 6.1.788A9.7 9.7 0 0 1 10 0q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 20 10a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 10 20"
    />
  </svg>
);
export default DollarSignFilled;